import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const VerificationModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  userEmail // Adding email might be nice if available
}) => {
  const { isDarkMode } = useTheme();

  if (!isOpen) return null;

  const dialogBg = isDarkMode ? 'bg-gray-800' : 'bg-white';
  const textColor = isDarkMode ? 'text-gray-100' : 'text-gray-900';
  const textColorSecondary = isDarkMode ? 'text-gray-300' : 'text-gray-600';
  const borderColor = isDarkMode ? 'border-gray-700' : 'border-gray-100';
  const infoBg = isDarkMode ? 'bg-blue-900/30 border-blue-700' : 'bg-blue-50 border-blue-200';
  const infoText = isDarkMode ? 'text-blue-300' : 'text-blue-800';
  const detailBg = isDarkMode ? 'bg-gray-700' : 'bg-gray-50';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`rounded-2xl shadow-xl max-w-md w-full transform transition-all duration-300 scale-100 opacity-100 ${dialogBg}`}>
        {/* Header */}
        <div className={`p-6 border-b ${borderColor}`}>
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className={`text-lg font-semibold ${textColor}`}>
                Verificar Usuário
              </h3>
              <p className={`text-sm mt-1 ${textColorSecondary}`}>
                Confirma a ativação deste usuário?
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className={`border rounded-lg p-4 ${infoBg} ${infoText}`}>
            <div className="flex items-start gap-3">
              <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="text-sm">
                <p className="font-medium">Ao verificar este usuário:</p>
                <ul className="mt-2 space-y-1">
                  <li>• Status será alterado para "verificado"</li>
                  <li>• Badge "NOVO" será removido</li>
                  <li>• Usuário terá acesso completo ao sistema</li>
                </ul>
              </div>
            </div>
          </div>

          {(userName || userEmail) && (
            <div className={`mt-4 p-3 rounded-lg ${detailBg}`}>
              {userName && (
                <p className={`text-sm ${textColorSecondary}`}>
                  <span className="font-medium">Usuário:</span> {userName}
                </p>
              )}
              {userEmail && (
                <p className={`text-sm ${textColorSecondary}`}>
                  <span className="font-medium">Email:</span> {userEmail}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className={`flex gap-3 p-6 border-t ${borderColor}`}>
          <button
            onClick={onClose}
            className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 ${isDarkMode
              ? 'text-gray-300 bg-gray-700 border-gray-600 hover:bg-gray-600 focus:ring-gray-500/20'
              : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:ring-gray-500/20'
              }`}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500/50 shadow-sm"
          >
            <div className="flex items-center justify-center gap-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              Confirmar Verificação
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationModal;
